import { RouteComponentProps } from "@reach/router";
import { FunctionComponent, lazy } from "react";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../shared/ErrorFallback";

const LazyInfo = lazy(() => import(/* webpackChunkName: "Info" */ "./Info"));

const InfoPage: FunctionComponent<RouteComponentProps> = () => {
	return <ErrorBoundary FallbackComponent={ErrorFallback}>
		<LazyInfo />
	</ErrorBoundary>;
};

export default InfoPage;